var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "badge badge-pill mr-2 mb-3",
      class: _vm.isActive ? "badge-light-active" : "badge-light",
      on: { click: _vm.setActive }
    },
    [
      _vm.isActive
        ? _c("i", { staticClass: "fas fa-check-circle fa-lg" })
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm._f("multiLangName")(_vm.topic)) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56a8707f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a8707f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/Chips.vue
// module id = 1668
// module chunks = 0